import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FileIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M13.52 4.08L18.18 8.74V19.84H5.82V4.08H13.52ZM7.46 18.2H16.54V9.94H12.32V5.72H7.46V18.2Z" />
    </SvgIcon>
  );
});
